<template>
    <div>
        <!-- 关联事件 -->
        <el-form :inline="true" :model="form">
            <el-form-item>
                <el-input v-model="form.keyword" placeholder="请输入关键字"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="loadData">搜索</el-button>
            </el-form-item>
        </el-form>
        <div>
            <el-table :data="tableData" v-loading="loading" ref="table" @selection-change="handleSelectionChange">
                <el-table-column label="序号" width="70" align="center">
                    <template slot-scope="scope">
                        <span v-if="form.pageSize===10"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*10 : scope.$index+1}}</span>
                        <span v-if="form.pageSize===20"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*20 : scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="编号" prop="serialNumber"></el-table-column>
                <el-table-column label="标题" prop="title"></el-table-column>
                <el-table-column label="分类" prop="category">
                    <template slot-scope="scope">
                        {{ scope.row.category | tableVal(categoryList,'t') }}
                    </template>
                </el-table-column>
                <el-table-column label="请求人" prop="requester"></el-table-column>
                <el-table-column label="指派人" prop="designator"></el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        {{ scope.row.status | tableVal(eventStatus) }}
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" prop="createTime" width="140"></el-table-column>
                <el-table-column label="SLA状态" minWidth="140">
                    <template slot-scope="scope">
                        {{ scope.row.slaStatus | tableVal(slaStatus) }}
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="form.pageIndex"
                           :page-sizes="[10,20]"
                           :page-size="form.pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>

        <div style="margin:70px 0 10px 0;display: flex;">
            <el-button type="primary" @click="submit">确定</el-button>
            <el-button type="default" @click="onCancel">取消</el-button>
        </div>
    </div>
</template>

<script>
    import services from "../../services/common.service"
    import commonService from "../../services/common.service";
    export default {
        props:{
            callback:Function,
            data:Array
        },
        data() {
            return {
                tableData:[],
                loading:true,
                form:{
                    pageIndex:1,
                    pageSize:10,
                    keyword:""
                },
                multipleSelection: [],
                total:null,
                categoryList:[],     // 事件分类
            }
        },
        created() {
            this.request();
            this.getCategoryList();     // 获取事件分类
        },

        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            eventStatus(){
                return this.dictionary.event_status;
            },
            slaStatus(){
                return this.dictionary.sla_status;
            },
            // 事件分类id
            eventType(){
                return this.$store.state.caseType.event;
            }
        },
        methods: {
            loadData(){
                this.form.pageIndex=1
                this.request()
            },
            request(){
                // this.tableData = [];
                // this.total = null;
                // this.loading = true;
                services.getEventList(this.form).then(res => {
                    this.tableData = res.list;
                    this.total = res.total;
//                    this.$nextTick(function(){
//                        this.checked();
//                    })
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            // 获取事件分类
            getCategoryList(){
                commonService.categoryList(this.eventType.id).then(res => {
                    this.categoryList = res;
                })
            },
            checked(){
                let ids = this.data.map(item => { return item.serialNumber });
                let index;
                this.tableData.forEach((item,i) => {
                    if(item.serialNumber == ids[0]){
                        index =  i;
                    }
                });
                this.$refs.table.toggleRowSelection(this.tableData[index],true);
            },
            handleSelectionChange(val){
                this.multipleSelection = val;
            },
            submit(){
                if(this.multipleSelection.length == 0){
                    this.$message.error("请至少选择一个")
                }else{
                    this.callback(this.multipleSelection);
                    this.$modal.close();
                }
            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            },

            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.pageSize = val;
                if(this.form.pageIndex > pages ){
                    this.form.pageIndex  = 1;
                };
                this.request()
            },
            handleCurrentChange(val){
                this.form.pageIndex = val;
                this.request();
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
